<template>
  <div id="app" :class="{ menuCenter: $route.fullPath.includes('/auctions/create') }">
    <div class="loading" v-if="showLoading">
      <div class="loading-content">
        <div class="spinner">{{ showLoadingText }}</div>
      </div>
    </div>
    <v-snackbar v-model="snackbarVisible" bottom color="info" class="snack" center :timeout="3000">
      <span style="color: #fff" class="d-inline-block pr-2">{{ snackbarText }}</span>
      <v-btn color="pink" text @click="snackbarVisible = false">
        <span style="color: #2e7f89">Close</span>
      </v-btn>
    </v-snackbar>
    <v-app id="inspire" :style="{ backgroundColor: backGroundColor, backgroundImage: getImage() }">
      <div id="nav" class="navbar-panel" :style="{ backgroundColor: colorHeader }">
        <div class="nav-group">
          <router-link to="/auctions" class="menu-item logo" v-if="loginInfo.isLogged">
            <img src="./assets/logo.png" alt="AUK - marketplace" />
          </router-link>
          <router-link to="/" class="menu-item logo" v-else>
            <img src="./assets/logo.png" alt="AUK - marketplace" />
          </router-link>
          <div v-if="loginInfo.isLogged" class="nav-group nav-center">
            <router-link class="menu-item" to="/auctions"> Auctions </router-link>
            <router-link class="menu-item" to="/auctions/create"> Create Auction </router-link>
          </div>
        </div>
        <div class="nav-group">
          <router-link to="/" class="menu-item" v-if="!loginInfo.isLogged"> Login </router-link>
          <router-link to="/registration" class="menu-item" v-if="!loginInfo.isLogged">
            Registration
          </router-link>
          <a v-if="showUserGuide" :href="simpleData.userGuide" target="_blank">User Guide</a>
          <router-link to="/contacts" class="menu-item"> Contact Us </router-link>
          <v-menu offset-y class="dropdown-menu" nudge-bottom="-15">
            <template #activator="{ on }">
              <div class="d-flex align-center">
                <a v-if="loginInfo.isLogged" class="avatar" v-on="on">
                  <img v-if="profileInfo.userImage" :src="profileImageUrl" alt="user image" />
                  <img src="./assets/user-image-.png" v-else alt="user image" />
                  <span>{{ profileInfo.username ? profileInfo.username : 'My account' }}</span>
                </a>
              </div>
            </template>
            <v-list>
              <v-list-item class="dropdown-item" @click.prevent="$router.push({ name: 'profile' })">
                <v-list-item-title>View Profile</v-list-item-title>
              </v-list-item>
              <v-list-item class="dropdown-item" @click.prevent="logoutAndRedirect">
                <v-list-item-title>Log Out</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>
      <router-view />
    </v-app>
  </div>
</template>

<script>
import SimpleService from '@/services/SimpleService';
import { FEATURE_FLAGS } from '@/constants/featureFlags';
import { mapActions, mapMutations, mapState } from 'vuex';
export default {
  created() {
    this.bidderCreatedBid(false);
    SimpleService.getStaticData().then((resp) => {
      this.setSimpleData(resp.data);
    });
    this.setLoading({ show: false, text: '' });
    if (localStorage.getItem('mainColor')) {
      this.setBackGroundColor(localStorage.getItem('mainColor'));
    }
    if (localStorage.getItem('colorHeader')) {
      this.setColorHeader(localStorage.getItem('colorHeader'));
    }
    if (localStorage.getItem('backgroundImage')) {
      this.setBackgroundImage(localStorage.getItem('backgroundImage'));
    }
  },
  methods: {
    ...mapActions(['inspectToken', 'setLoading']),
    ...mapMutations([
      'bidderCreatedBid',
      'setSimpleData',
      'setBackGroundColor',
      'setColorHeader',
      'setBackgroundImage',
      'setSnackbarState',
      'logout',
    ]),
    getImage() {
      if (this.backgroundImage !== 'none') {
        return 'url(' + this.backgroundImage + ') !important';
      } else {
        return 'none';
      }
    },
    logoutAndRedirect() {
      this.logout();
      this.$router.push({ name: 'login' });
    },
  },
  updated() {
    this.inspectToken();
  },
  computed: {
    ...mapState([
      'showLoading',
      'showLoadingText',
      'isShowSnackbar',
      'snackbarText',
      'loginInfo',
      'simpleData',
      'profileInfo',
      'apiUrl',
      'backGroundColor',
      'colorHeader',
      'backgroundImage',
    ]),
    snackbarVisible: {
      get() {
        return this.isShowSnackbar;
      },
      set(value) {
        this.setSnackbarState({
          show: value,
          text: value ? this.snackbarText : '',
        });
      },
    },
    profileImageUrl() {
      if (!this.profileInfo.userImage) return '';
      return this.apiUrl.substring(0, this.apiUrl.length - 1) + this.profileInfo.userImage;
    },
    showUserGuide() {
      if (!FEATURE_FLAGS.enableUserGuide) return false;
      const url = this.simpleData.userGuide;
      return typeof url === 'string' && url.trim() !== '';
    },
  },
};
</script>

<style lang="scss">
.page-title {
  margin: 80px auto 32px;
  font-size: 28px;
  font-weight: 600;
  line-height: 1.2;
  color: #000;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
#app .primary--text {
  color: #20757f !important;
  caret-color: #1976d2 !important;
}
@font-face {
  font-family: 'Montserrat';
  src: url('assets/fonts/Montserrat/Montserrat-Medium.ttf');
}
@font-face {
  font-family: 'Montserrat-SemiBold';
  src: url('assets/fonts/Montserrat/Montserrat-SemiBold.ttf');
}
body {
  margin: 0;
  padding: 0;
  font-family: 'Montserrat', Helvetica, Arial, sans-serif;
}

.v-application {
  font-family: 'Montserrat', Helvetica, Arial, sans-serif !important;
}

div#inspire {
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #dcdcdc;
}

.v-card__title--primary {
  padding-top: 16px;
}

#app {
  
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: relative;
}

#app .primary {
  background-color: #2e7f89 !important;
  border-color: #2e7f89 !important;
}

.nav-group {
  display: flex;
}
.card-text {
  
  font-size: 13px;
}
#nav {
  margin: 0;
  padding-left: 30px;
  padding-right: 30px;
  color: #216169;
  
  text-transform: uppercase;
}

.theme--light.v-text-field--outline > .v-input__control > .v-input__slot,
.theme--light.v-text-field--outline:not(.v-input--is-focused):not(.v-input--has-state)
  > .v-input__control
  > .v-input__slot:hover {
  border: none;
}

.v-text-field--box > .v-input__control > .v-input__slot,
.v-text-field--full-width > .v-input__control > .v-input__slot,
.v-text-field--outline > .v-input__control > .v-input__slot {
  min-height: auto;
  margin: 0;
}

.loader {
  position: absolute;
  z-index: 999;
  background: grey;
  height: 100vh;
  width: 100%;
}

.v-text-field.v-text-field--enclosed .v-input__append-inner,
.v-text-field.v-text-field--enclosed .v-input__append-outer,
.v-text-field.v-text-field--enclosed .v-input__prepend-inner,
.v-text-field.v-text-field--enclosed .v-input__prepend-outer {
  margin-top: 4px;
}

.theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
  background: #ebebeb;
}

.theme--light.v-messages,
.v-text-field__details,
.v-text-field.v-text-field--enclosed .v-text-field__details {
  display: none;
}

#items-dialog .theme--light.v-messages,
.v-text-field__details,
.v-text-field.v-text-field--enclosed .v-text-field__details {
  display: block !important;
}

.v-select__selections {
  padding-top: 0 !important;
}

.dropdown-item {
  cursor: pointer;
}
.input-group__details {
  display: none;
  &:before {
    display: none;
  }
  &:after {
    display: none;
  }
}
.dropdown-menu {
  display: flex !important;
  flex-direction: row;
  align-items: center;
}

.avatar {
  &:before {
    display: none;
  }
  img {
    height: 25px;
    width: 25px;
  }
}

.logo {
  font-weight: 700 !important;
  font-size: 14px !important;
  &:before {
    display: none;
  }
}

.snack {
  width: fit-content;
  margin: 0 auto;
  border: none !important;
}

@media (max-width: 820px) {
  .menu.dropdown-menu {
    margin-top: 20px;
  }
  .logo {
    margin-bottom: 20px;
  }
  #nav {
    padding: 30px;
    height: auto;
  }
  .nav-group,
  .navbar-panel {
    display: flex;
    flex-direction: column !important;
    align-items: center;
    justify-content: center;

    a {
      line-height: 28px;
    }
  }
  .avatar {
    img {
      height: 32px;
      width: auto;
    }
  }
}

#nav a {
  text-decoration: none;
  font-weight: 400;
  font-size: 14px;
  color: #125159;
}

@media screen and (max-width: 620px) and (max-width: 500px) {
  #nav {
    padding-left: 0;
    padding-right: 0;
  }
}

.navbar-panel {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: #ffffff;
  height: 70px;
  align-items: stretch;
  span {
    text-transform: none;
    margin-left: 12px;
  }
  a {
    display: flex;
    padding: 0 30px;
    align-items: center;
    text-align: center;
    position: relative;

    .router-link-exact-active {
      background-color: #217bb8;
    }
    &:before {
      position: absolute;
      left: 51%;
      right: 50%;
      bottom: 0;
      content: '';
      height: 2px;
      background-color: #2e7f89;
      transition: all 0.3s ease-in-out;
    }
    &:hover:before {
      left: 0;
      right: 0;
    }
  }
}

.loading {
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  z-index: 999;
  position: absolute;
}

.loading-content {
  position: relative;
  height: 300px;
  width: 300px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.spinner {
  height: 60px;
  width: 100%;
  background: url('./assets/loader.gif') no-repeat center;
  font-size: 100%;
}

@media screen and (max-width: 500px) {
  .logout-button {
    display: block;
    height: 50px;
    padding-top: 19px;
  }
}

.application {
  line-height: normal;
}

@media screen and (max-width: 620px) {
  .logout-button {
    margin-left: 0;
  }
}

.menuCenter {
  .v-list-item__title {
    text-align: left !important;
  }
}
</style>
